var React = require('react');

function DropdownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.3517 34.6483C15.1239 35.4205 16.376 35.4205 17.1483 34.6483L28 23.7966L38.8517 34.6483C39.6239 35.4205 40.876 35.4205 41.6483 34.6483C42.4205 33.876 42.4205 32.6239 41.6483 31.8517L29.3983 19.6017C29.0274 19.2308 28.5244 19.0225 28 19.0225C27.4755 19.0225 26.9725 19.2308 26.6017 19.6017L14.3517 31.8517C13.5794 32.6239 13.5794 33.876 14.3517 34.6483Z","fill":"currentColor"}));
}

DropdownInline.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = DropdownInline;

DropdownInline.default = DropdownInline;
